import { useLingui } from "@lingui/react"

import { Locale } from "../../locales/constants"
import { isValidLocale } from "../../locales/locales"

/**
 * Returns the current locale based on lingui, with type safety.
 * @returns Locale the current locale
 * @throws an error if the locale is not supported. This should never happen, since the app should break before this.
 */
export function useLocale(): Locale {
  const {
    i18n: { locale },
  } = useLingui()

  if (!isValidLocale(locale)) {
    throw new Error(`Locale ${locale} is not supported.`)
  }

  return locale
}
